import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-4 text-center" }, "Avis sur l’offre", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center text-muted"
}
const _hoisted_5 = {
  key: 2,
  class: "row"
}
const _hoisted_6 = { class: "card shadow-sm border-0 h-100" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "text-muted fst-italic mb-3" }
const _hoisted_10 = { class: "text-end text-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Chargement..."))
      : (_ctx.avisList.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Aucun avis pour cette offre. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.avisList, (a, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-md-6 mb-4"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h5", _hoisted_8, _toDisplayString(a.prenom) + " " + _toDisplayString(a.nom), 1),
                    _createElementVNode("p", _hoisted_9, " Commentaire : \"" + _toDisplayString(a.commentaire) + "\" ", 1),
                    _createElementVNode("p", _hoisted_10, [
                      _createElementVNode("small", null, "Posté le " + _toDisplayString(_ctx.formatDate(a.dateCommentaire)), 1)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]))
  ]))
}